// extracted by mini-css-extract-plugin
export default {"disabled":"oWkuvDkI5mIsOzyvbpjX","active":"UoLYh_V4Zueje1G1jIcA"};